import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import i18n from "~/assets/js/Helpers/i18n";
import Headline from "../Typography/Headline";
import { formatPrice } from "~/assets/js/Format";

const OrderSummary = ({ order }) => {
    const [state, setState] = useState({
        subtotal: 0,
        delivery: {},
        discount: {},
        envCompensation: {},
    });
    const hasEnergyFee = parseFloat(order?.energy_fee?.value_gross || "0") > 0;

    const getEnergyFeeValue = () => {
        try {
            if (order?.energy_fee) {
                return parseFloat(order.energy_fee.value_gross);
            }

            return 0;
        } catch (error) {
            return 0;
        }
    };

    useEffect(() => {
        const calculateSubtotal = () => {
            let subtotal = 0;
            const products = order.items;
            products.map((product) => {
                subtotal = subtotal + parseFloat(product.value_gross);
            });

            return formatPrice(subtotal);
        };
        const calculateDiscounts = () => {
            let discount = order.discount.value_gross_coupon;
            return {
                display: parseInt(discount) !== 0,
                value: formatPrice(discount),
            };
        };
        const calculateDelivery = () => {
            const deliveryValue = order?.shipping?.value_gross;

            const displayDelivery = ![0, "0", null, undefined].includes(
                deliveryValue
            );

            return {
                display: displayDelivery,
                value: formatPrice(deliveryValue),
            };
        };
        const calculateCompensations = () => {
            return {
                value: formatPrice(order.compensation.value_gross),
                display: !!order.compensation.value_gross,
            };
        };

        setState({
            subtotal: calculateSubtotal(),
            delivery: calculateDelivery(),
            discount: calculateDiscounts(),
            envCompensation: calculateCompensations(),
        });
    }, []);

    return (
        <div className="summary">
            <Headline size={5}>{i18n.t("cart.summary.label")}</Headline>
            <div className="summary__row">
                <span className="summary__label">
                    {i18n.t("cart.summary.subtotal")}
                </span>
                <span className="summary__sublabel">{state.subtotal}</span>
            </div>
            {state.delivery.display && (
                <div className="summary__row">
                    <div className="summary__labels-wrapper">
                        <span className="summary__label">
                            {i18n.t("cart.summary.shipment")}
                        </span>
                    </div>

                    <span className="summary__sublabel">
                        {state.delivery.value}
                    </span>
                </div>
            )}
            {state.discount.display && (
                <div className="summary__row">
                    <span className="summary__label">
                        {i18n.t("cart.summary.voucher")}
                    </span>
                    <span className="summary__sublabel">
                        {state.discount.value}
                    </span>
                </div>
            )}
            {state.envCompensation.display && (
                <div className="summary__row">
                    <span className="summary__label">
                        {i18n.t("cart.compensation")}
                    </span>
                    <span className="summary__sublabel">
                        {state.envCompensation.value}
                    </span>
                </div>
            )}
            {hasEnergyFee && (
                <>
                    <div className="summary__row">
                        <span className="summary__label">
                            {i18n.t("cart.energyFee.title")}
                        </span>
                        <span className="summary__sublabel">
                            {formatPrice(getEnergyFeeValue())}
                        </span>
                    </div>
                </>
            )}
            <hr className="summary__divider" />
            <div className="summary__row">
                <div className="summary__labels-wrapper">
                    <span className="summary__total">
                        {i18n.t("cart.summary.total")}
                    </span>
                    <span className="summary__sublabel">
                        {i18n.t("cart.summary.vat")}
                    </span>
                </div>
                <span className="summary__total">
                    {formatPrice(order.value_gross)}
                </span>
            </div>
        </div>
    );
};

OrderSummary.propTypes = {
    order: PropTypes.object.isRequired,
};

export default OrderSummary;
